import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

/*
   Temporary mock fetch functions
   Later replace with API calls
*/

const fetchClient = async (clientId) => {
  return {
    id: clientId,
    name: "ABC Pvt Ltd"
  };
};

const fetchService = async (serviceId) => {
  const services = {
    1: { id: 1, name: "GST Monthly Filing" },
    2: { id: 2, name: "TDS Returns" },
    3: { id: 3, name: "Statutory Audit" }
  };

  return services[serviceId];
};

const ClientServiceAgreement = () => {

  const { clientId, serviceId } = useParams();

  const [client, setClient] = useState(null);
  const [service, setService] = useState(null);
  const [activeTab, setActiveTab] = useState("scope");

  /* Load client + service dynamically */
  useEffect(() => {
    const loadData = async () => {
      const clientData = await fetchClient(clientId);
      const serviceData = await fetchService(serviceId);

      setClient(clientData);
      setService(serviceData);
    };

    loadData();
  }, [clientId, serviceId]);

  if (!client || !service) {
    return <div className="p-6 text-slate-500">Loading agreement...</div>;
  }

  return (
    <div className="max-w-6xl mx-auto">

      {/* ===== HEADER ===== */}
      <div className="mb-6">

        <h2 className="text-xl font-black text-slate-900">
          {service.name} Agreement
        </h2>

        <p className="text-sm text-slate-500">
          {client.name}
        </p>

      </div>

      {/* ===== TABS ===== */}
      <div className="flex gap-6 border-b mb-6">

        {["scope","commercial","responsibility","deliverables","documents","notes"].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-2 text-sm font-semibold capitalize ${
              activeTab === tab
                ? "border-b-2 border-indigo-600 text-indigo-600"
                : "text-slate-400"
            }`}
          >
            {tab}
          </button>
        ))}

      </div>

      {/* ===== TAB CONTENT ===== */}
      <div className="bg-white border rounded-2xl p-6">

        {activeTab === "scope" && (
          <div>
            <h3 className="font-bold mb-3">Scope of Work</h3>

            <div className="space-y-2">
              <label><input type="checkbox" /> GSTR-1 Filing</label>
              <label><input type="checkbox" /> GSTR-3B Filing</label>
              <label><input type="checkbox" /> Annual Return</label>
              <label><input type="checkbox" /> Advisory</label>
            </div>
          </div>
        )}

        {activeTab === "commercial" && (
          <div className="grid md:grid-cols-2 gap-4">
            <input placeholder="Fee Amount" className="border rounded-xl px-3 py-2" />
            <input placeholder="Billing Frequency" className="border rounded-xl px-3 py-2" />
            <textarea
              placeholder="Payment Terms"
              className="border rounded-xl px-3 py-2 md:col-span-2"
            />
          </div>
        )}

        {activeTab === "responsibility" && (
          <textarea
            rows={5}
            className="border rounded-xl px-3 py-2 w-full"
            placeholder="Define responsibility matrix..."
          />
        )}

        {activeTab === "deliverables" && (
          <textarea
            rows={5}
            className="border rounded-xl px-3 py-2 w-full"
            placeholder="Define deliverables..."
          />
        )}

        {activeTab === "documents" && (
          <input type="file" className="border rounded-xl px-3 py-2 w-full" />
        )}

        {activeTab === "notes" && (
          <textarea
            rows={5}
            className="border rounded-xl px-3 py-2 w-full"
            placeholder="Internal notes..."
          />
        )}

      </div>

      {/* ACTION BUTTONS */}
      <div className="flex justify-end mt-6 gap-3">

        <button className="px-4 py-2 border rounded-xl">
          Cancel
        </button>

        <button className="px-4 py-2 bg-indigo-600 text-white rounded-xl">
          Save Agreement
        </button>

      </div>

    </div>
  );
};

export default ClientServiceAgreement;
